module.exports = __webpack_public_path__ + "static/media/patient-flow-chart.3f1253b8.png";